module.exports = __webpack_public_path__ + "static/img/icon_avatar.d9830c26.png";